<template>
  <div class="colorful-background wrapper-grid special">
    <div :class="['title', { animate__animated: isFirst }, 'animate__flipInX']">
      <span class="up-small-font">您第一次预约座位在</span>
      <span class="big-font">
         {{ this.$store.state.$data.data.seat.first.timeBefore }}天前
      </span>
      <span class="small-font">{{ sloganForShow }}</span>
    </div>

    <div
      :class="[
        'text',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'text-align-right',
      ]"
      style="align-items: flex-end;"
    >
      <span class="up-small-font is-inline">在图书馆</span>
      <span class="big-font is-inline"> {{ this.$store.state.$data.data.seat.first.at }}</span>
      <span class="up-small-font is-block">邂逅了什么呢？</span>
    </div>

    <div :class="['img', { animate__animated: isFirst }, 'animate__fadeIn']">
      <image-box img-u-r-l="/pic/8.png"></image-box>
    </div>

    <div
      :class="[
        'slogan',
        { animate__animated: isFirst },
        'animate__fadeIn',
        ' big-margin-top',
      ]"
    >
      <span class="small-font">{{ randomSloganForShow }}</span>
    </div>

    <div class="footer middle-margin-bottom">
      <span class="very-small-font"
        >数据由杭电图书馆提供,分析数据均在理想情况下计算</span
      >
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'

export default {
  name: 'cardPage',
  components: { ImageBox },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  data() {
    return {
      sloganForShow: '',
      randomSloganForShow: '',
      timeMap: new Map([
        ['morning', '早晨'],
        ['afternoon', '下午'],
        ['noon', '中午'],
        ['evening', '夜晚'],
      ]),
      slogan: ['消费有点少哎,可以多来尝尝食堂的饭菜呀'],
      randomSlogan: [
        '小助手听说五餐早饭的葱油面特别好吃',
        '食堂的饭菜好吃吗?小助手也想尝尝',
        '小助手听说杭电的食堂有许多特色菜',
      ],
    }
  },
  computed: {
    card: function () {
      return store.state.$data.data.Card
    },
  },
  mounted() {
    // let CardSpend = store.state.$data.data.Card.Total
    // if (CardSpend < 100) {
    //   this.sloganForShow = this.slogan[0]
    // }
    // this.randomSloganForShow = this.randomSlogan[Math.round(Math.random() * 2)]
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--first-delay);
}

.text.animate__animated {
  animation-delay: var(--second-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}
.special.wrapper-grid {
  --first-color: var(--rose-gold);
  --page-background-color: var(--light-orange);
  --second-color: var(--cherry-pink);
  --angle: 135deg;
  grid-template-rows: 5vh repeat(4, minmax(auto, auto)) 1fr 5vh;
  grid-template-areas:
    '. .      .'
    '. title  .'
    '. img    .'
    '. text   .'
    '. slogan .'
    '. .      .'
    '. footer .';
}
</style>
